export default "__VITE_ASSET__uiBnQlEy__"